(() => {
  const root = document.querySelector('[data-cleaning-finder]');
  if (!root) return;

  const copy = JSON.parse(root.querySelector('[data-finder-copy]').textContent);
  const choices = root.querySelector('[data-finder-choices]');
  const result = root.querySelector('[data-finder-result]');
  const stepLabel = root.querySelector('[data-finder-step-label]');
  const path = root.querySelector('[data-finder-path]');
  const back = root.querySelector('[data-finder-back]');
  const storage = root.querySelector('[data-finder-storage]');

  const methods = {
    sweep: { floor: ['sweep'], dry: ['flour', 'sweep', 'small'] },
    squeegee: { floor: ['squeegee'], surface: ['squeegee'] },
    scrub: { floor: ['scrub'], surface: ['scrub'], machine: ['angle'], tank: ['vessel'] },
    brush: { surface: ['brush'], machine: ['crevice', 'fine'], pipe: ['outside', 'inside'] },
    scrape: { floor: ['scrape'], surface: ['scrape'], tank: ['scrape'] }
  };
  const products = {
    floor: {
      sweep: ['besen-haccp', 'esd-besen', 'detektierbar-besenkopf', null],
      squeegee: ['abzeiher-400mm-einlippig-haccp', null, null, null],
      scrub: ['schrubber-28cm', null, null, null],
      scrape: ['bodenschaber', 'esd-schaber', null, null]
    },
    surface: {
      brush: ['handburste-kurz-haccp', 'esd-waschburste', 'detektierbar-handwaschburste', 'anti-bac-waschburste-88306'],
      scrub: ['handschrubber-haccp', 'esd-waschburste', 'detektierbar-handwaschburste', 'anti-bac-scheuerburste'],
      squeegee: ['hand-wasserabzieher-mit-angespritzer-lippe', null, null, null],
      scrape: ['schaber-schlesinger-haccp', 'esd-spachtel', 'detektierbar-spachtel', null]
    },
    machine: {
      crevice: ['fugenburste-haccp', 'esd-fugenburste', 'detektierabar-fugenburste', null],
      angle: ['winkelschrubber-haccp', null, null, null],
      fine: ['spulburste-mit-kratzkante-haccp', null, null, 'anti-bac-spulburste-rund']
    },
    pipe: {
      outside: ['aussenrohrburste-haccp', 'esd-aussenrohrburste', null, null],
      inside: ['rohrburste-mit-v2a-edelstahldraht', null, null, null]
    },
    tank: {
      vessel: ['kesselburste-haccp', 'esd-kesselburste', 'detektierbar-kesselburste', null],
      scrape: ['spachtel-haccp-hart', 'esd-spachtel', 'detektierbar-spachtel', null]
    },
    dry: {
      flour: ['mehlbesen-haccp', null, null, 'anti-bac-mehlbesen'],
      sweep: ['handfeger-haccp', 'esd-handfeger', 'detektierbar-handfeger', 'anti-bac-handbesen'],
      small: ['handfeger-haccp', 'esd-handfeger', 'detektierbar-handfeger', 'anti-bac-handbesen']
    }
  };
  const requirementIds = ['hygiene', 'esd', 'detectable', 'antibac'];
  const collectionPaths = {
    hygiene: '/collections/reinigungswerkzeuge',
    esd: '/collections/esd-bursten',
    detectable: '/collections/reinigungsgerate-detektierbar',
    antibac: '/collections/anti-bac'
  };
  const icons = {
    sweep: '<path d="M5 20h14M8 18l5-13m-2 12 8 3M13 5l1-2"/>',
    squeegee: '<path d="M4 6h16v4H4zM12 10v11M8 21h8"/>',
    scrub: '<path d="M5 15h14v5H5zM7 15V7h10v8M8 20v2m4-2v2m4-2v2"/>',
    brush: '<path d="M4 16 16 4l4 4L8 20l-4-4ZM7 19l-2 2m6-5 2 2m1-5 2 2"/>',
    scrape: '<path d="M4 5h16v5H4zM10 10v10h4V10M7 20h10"/>'
  };
  const state = { method: null, category: null, task: null, requirement: null };
  let requestId = 0;
  let currentStep = 'method';

  function button(label, value, icon) {
    const element = document.createElement('button');
    element.type = 'button';
    element.className = 'ol-cleaning-finder__choice';
    element.dataset.value = value;
    if (icon) {
      const symbol = document.createElement('span');
      symbol.className = 'ol-cleaning-finder__icon';
      symbol.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + icon + '</svg>';
      element.append(symbol);
    }
    const text = document.createElement('span');
    text.textContent = label;
    element.append(text);
    const arrow = document.createElement('span');
    arrow.className = 'ol-cleaning-finder__arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '→';
    element.append(arrow);
    return element;
  }

  function setStep(step) {
    requestId += 1;
    result.hidden = true;
    result.replaceChildren();
    storage.hidden = true;
    choices.hidden = false;
    choices.replaceChildren();
    back.hidden = step === 'method';
    currentStep = step;
    stepLabel.textContent = step === 'method' ? copy.stepOne : step === 'area' ? copy.stepTwo : step === 'detail' ? copy.stepDetail : copy.stepThree;
    path.textContent = [state.method && copy.methods[state.method], state.category && copy.categories[state.category],
      step === 'requirement' && state.task && methods[state.method][state.category].length > 1 && copy.tasks[state.task]]
      .filter(Boolean).join(' · ');
    let ids;
    let labels;
    if (step === 'method') {
      ids = Object.keys(methods);
      labels = copy.methods;
    } else if (step === 'area') {
      ids = Object.keys(methods[state.method]);
      labels = copy.categories;
    } else if (step === 'detail') {
      ids = methods[state.method][state.category];
      labels = copy.tasks;
    } else {
      ids = requirementIds;
      labels = copy.requirements;
    }
    ids.forEach((id) => {
      const item = button(labels[id], id, step === 'method' ? icons[id] : null);
      item.addEventListener('click', () => {
        if (step === 'method') {
          state.method = id;
          state.category = null;
          state.task = null;
          state.requirement = null;
          setStep('area');
        } else if (step === 'area') {
          state.category = id;
          state.task = null;
          state.requirement = null;
          const availableTasks = methods[state.method][id];
          if (availableTasks.length === 1) {
            state.task = availableTasks[0];
            setStep('requirement');
          } else {
            setStep('detail');
          }
        } else if (step === 'detail') {
          state.task = id;
          state.requirement = null;
          setStep('requirement');
        } else {
          state.requirement = id;
          showResult();
        }
      });
      choices.append(item);
    });
    root.dataset.currentStep = step;
  }

  function createLink(href, label, primary) {
    const link = document.createElement('a');
    link.href = href;
    link.className = primary ? 'ol-cleaning-finder__cta' : 'ol-cleaning-finder__secondary';
    link.textContent = label;
    return link;
  }

  async function showResult() {
    const id = ++requestId;
    const handle = products[state.category][state.task][requirementIds.indexOf(state.requirement)];
    const categoryUrl = collectionPaths[state.requirement];
    stepLabel.textContent = copy.resultTitle;
    path.textContent = [copy.methods[state.method], copy.categories[state.category], copy.requirements[state.requirement]].join(' · ');
    choices.hidden = true;
    result.hidden = false;
    result.replaceChildren();
    storage.hidden = true;
    currentStep = 'result';
    root.dataset.currentStep = 'result';

    if (!handle) {
      const title = document.createElement('h3');
      title.textContent = copy.specialNote;
      result.append(title, createLink(categoryUrl, copy.browseSpecial, true));
      return;
    }

    try {
      const response = await fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Product lookup failed');
      const product = await response.json();
      if (id !== requestId) return;
      if (!product.available) throw new Error('Product unavailable');

      const card = document.createElement('div');
      card.className = 'ol-cleaning-finder__product';
      if (product.featured_image) {
        const image = document.createElement('img');
        image.src = product.featured_image.startsWith('//') ? 'https:' + product.featured_image : product.featured_image;
        image.alt = '';
        image.width = 220;
        image.height = 220;
        image.loading = 'lazy';
        card.append(image);
      }
      const details = document.createElement('div');
      const eyebrow = document.createElement('p');
      eyebrow.className = 'ol-cleaning-finder__match';
      eyebrow.textContent = copy.resultSubtitle;
      const title = document.createElement('h3');
      title.textContent = window.OptileanBristles ? window.OptileanBristles.copyForHandle(handle).productTitle || product.title : product.title;
      const note = document.createElement('p');
      note.className = 'ol-cleaning-finder__hint';
      note.textContent = copy.variantsNote;
      const productLink = createLink('/products/' + handle, copy.viewProduct, true);
      details.append(eyebrow, title, note, productLink);
      if (window.OptileanBristles && ['besen-haccp', 'handfeger-haccp', 'abzeiher-400mm-einlippig-haccp'].includes(handle)) {
        const bristles = document.createElement('div');
        details.insertBefore(bristles, productLink);
        window.OptileanBristles.mountFinder(bristles, product, handle, (variant) => {
          productLink.href = window.OptileanBristles.productUrl(handle) + (variant ? '?variant=' + variant.id : '');
        });
      }
      card.append(details);
      result.append(card);
      storage.hidden = false;
    } catch (_error) {
      if (id !== requestId) return;
      const message = document.createElement('p');
      message.textContent = copy.unavailable;
      result.append(message, createLink(categoryUrl, copy.browseSpecial, true));
    }
  }

  back.addEventListener('click', () => {
    if (currentStep === 'result') setStep('requirement');
    else if (currentStep === 'requirement') setStep(methods[state.method][state.category].length > 1 ? 'detail' : 'area');
    else if (currentStep === 'detail') setStep('area');
    else setStep('method');
  });
  setStep('method');
})();
